import React, { useState, useContext, useEffect } from 'react'
import { ProfileLayout } from "../layout"
import css from "../billingAddress/address.module.scss"
import { Checkbox } from '../../../componentsV1/Checkbox'
import { AuthContext } from '../../../context/auth'
import { updateCustomerAddressesApi, currentUserApi } from '../../../api'
import { countryCode, getKeyByValue } from '../../../utils/country'

export const ShippingAddress = () => {
    const { setNotification, shippingAddressModal, setShippingAddressModal, setSelectedAddress, user, setUser, setIsLoading } = useContext(AuthContext)
    const [address, setAddress] = useState([])

    useEffect(() => {
        if (!shippingAddressModal) {
            setSelectedAddress(null)
        }
    }, [shippingAddressModal])


    const fetchCurrentUser = () => {
        setIsLoading(true)
        currentUserApi()
            .then(res => {
                if (res.data) {
                    setUser(res.data)
                    setIsLoading(false)
                }
            })
            .catch(() => {
                setIsLoading(false)
            })
    }



    useEffect(() => {
        setAddress(user?.customer?.shipping_addresses?.filter((item) => item.metadata?.type === 'shipping'))
    }, [user])

    const handlePrimary = (id) => {
        setIsLoading(true)
        if (address?.length > 1) {
            address?.map((item) => {
                Promise.all([updateCustomerAddressesApi(item.id, {
                    metadata: {
                        ...item.metadata,
                        is_primary: item.id == id ? true : false
                    }
                }
                )]).then(() => {
                    setNotification({
                        type: 'success',
                        message: 'Primary Shipping Address Updated!'
                    })
                    fetchCurrentUser()
                    setIsLoading(false)
                }).catch(() => {
                    setIsLoading(false)
                    setNotification({
                        type: 'red',
                        message: 'Something went wrong, please try again!'
                    })
                })
            })
        } else {
            setNotification({
                type: 'red',
                message: 'One Primary Shipping Address is required!'
            })
            setIsLoading(false)
        }
    }


    return (
        <ProfileLayout>
            <div className={css.wrapper}>
                <div className={css.header}>
                    <h4>Shipping Address</h4>
                    <button className={css.link} onClick={() => {
                        setShippingAddressModal(true)
                        setSelectedAddress(null)
                    }}><i className='far fa-plus'></i> Add New</button>
                </div>
                <div className={css.addressContainer}>
                    {address && address.length > 0 ?
                        address?.map((item) => {
                            return (
                                <div className={css.addressCard} key={item.id}>
                                    <div className={css.leftContainer}>
                                        <h5>{item.company} {item.metadata?.is_primary && <span>Primary</span>}</h5>
                                        <p>{item.address_1}, {item.city}, {item.province} {item.postal_code}, {getKeyByValue(countryCode, item?.country_code?.toUpperCase())}</p>
                                        <Checkbox label={'Make Primary'} checked={item?.metadata?.is_primary} onChange={() => handlePrimary(item.id)} isCustom />
                                    </div>
                                    <div className={css.rightContainer}>
                                        <button className={css.link} onClick={() => {
                                            setShippingAddressModal(true)
                                            setSelectedAddress(item)
                                        }} >Edit</button>
                                    </div>
                                </div>
                            )
                        })
                        : <div className={css.noItems}>
                            <span className='icon'>
                                <i class="fal fa-boxes"></i>
                            </span>
                            <p>No Shipping Address Yet.</p>
                        </div>
                    }
                </div>
            </div>
        </ProfileLayout>
    )
}